import { render, staticRenderFns } from "./EditHero.vue?vue&type=template&id=0643f10a&"
import script from "./EditHero.vue?vue&type=script&lang=js&"
export * from "./EditHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports